<template>
  <form class="vue-form" @submit.prevent="submit">
    <fieldset>
      <p>
        <label for="email">Email</label>
        <input
          type="email"
          name="email"
          id="field-email"
          required=""
          :class="{ error: !email.valid }"
          v-on:change="validationMessage = ''"
          v-on:blur="email.blurred = true"
          v-model="email.value"
        />
        <label
          v-show="email.blurred && !email.valid"
          for="field-email"
          class="error-message"
          ><em>Please enter a valid email address</em></label
        >
      </p>
      <p>
        <label for="password">Password</label>
        <input
          type="password"
          name="password"
          id="field-password"
          required=""
          :class="{ error: !password.valid }"
          v-on:change="validationMessage = ''"
          v-on:blur="password.blurred = true"
          v-model="password.value"
        />
        <label
          v-show="password.blurred && !password.valid"
          for="field-password"
          class="error-message"
          ><em>Please enter a valid password</em></label
        >
      </p>
      <p v-show="hasValidationMessage" class="error-message">
        {{ validationMessage }}
      </p>
    </fieldset>
    <p class="cta-wrapper align-centre">
      <button type="submit" :disabled="!isSubmittable">
        Log me in!
      </button>
    </p>
  </form>
</template>

<script>
const {
  VUE_APP_AUTH_API_URL,
  VUE_APP_ADMIN_URL,
  VUE_APP_OPERATIVE_URL
} = process.env

export default {
  name: 'LoginForm',
  data: getDefaultValues,
  computed: {
    isSubmittable() {
      return (
        !this.dirty ||
        (!this.submitting && this.email.valid && this.password.valid)
      )
    },
    hasValidationMessage() {
      return this.validationMessage.length > 0
    }
  },
  watch: {
    'email.value': function (value, oldValue) {
      if (value !== oldValue) this.dirty = true

      value.length >= 5 && this.validate('email', value)
    },
    'password.value': function (value) {
      this.validate('password', value)
    }
  },
  methods: {
    validate: function (type, value) {
      if (type === 'email') {
        this.email.valid = this.isEmail(value)
      }
      if (type === 'password') {
        this.password.valid = this.isPassword(value)
      }
    },
    submit: async function () {
      this.submitting = true

      const formData = {
        email: this.email.value,
        password: this.password.value
      }

      try {
        const {
          statusCode,
          token,
          role,
          validationMessage
        } = await authenticate(formData)

        if (statusCode !== 200) {
          this.submitting = false
          this.validationMessage = validationMessage

          return
        }

        persistToken(token)

        window.location.assign(getRedirectUrl(role))
      } catch (error) {
        this.submitting = false
        this.validationMessage =
          'An unknown error has occurred. Please try again later.'
      }
    },
    isEmail,
    isPassword
  }
}

function getDefaultValues() {
  return {
    dirty: false,
    email: {
      value: '',
      valid: false,
      blurred: false
    },
    password: {
      value: '',
      valid: false,
      blurred: false
    },
    submitting: false,
    submittable: false,
    validationMessage: ''
  }
}

const emailRegExp = /^[a-z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i

function isEmail(value) {
  return emailRegExp.test(value)
}

function isPassword(value) {
  // TODO Basic password requirements
  return value.length > 0
}

async function authenticate(formData) {
  const response = await fetch(VUE_APP_AUTH_API_URL, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })

  const { status: statusCode } = response

  const { token, role, message: validationMessage } = await response.json()

  return {
    statusCode,
    token,
    role,
    validationMessage
  }
}

function persistToken(value) {
  const expiryTimestamp = getFutureDate().toGMTString()

  const cookieParts = ['token=' + value, 'path=/', 'expires=' + expiryTimestamp]

  document.cookie = cookieParts.join(';')
}

function getFutureDate(daysIntoFuture = 1) {
  const date = new Date()

  date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * daysIntoFuture)

  return date
}

// TODO Prod URLs
function getRedirectUrl(role) {
  if (role === 'admin') {
    return VUE_APP_ADMIN_URL
  }

  return VUE_APP_OPERATIVE_URL
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
form {
  flex: 1;
  padding: 10px;
}

fieldset {
  padding: 0 23px 16px;
  border: 1px solid #424243;
  border-radius: 8px;
}

input {
  display: block;
  width: 93%;
  margin: 7px 0 0;
  font-size: 20px;
  border: 1px solid;
  border-radius: 8px;
  outline: none;
  transition: background-color 0.17s ease-out, box-shadow 0.17s ease-out;
}

input:hover,
input:focus {
  background-color: #fff;
  border-color: #e53935;
  box-shadow: 0 0 0 4px rgba(220, 20, 60, 0.4);
}

button {
  width: 100%;
  margin: 15px 0;
  padding: 35px 15px;
  font-size: 25px;
  font-weight: bold;
  border: 0;
  border-radius: 12px;
  font-family: Arial, Helvetica, sans-serif;
  color: #fff;
  background-color: #dc143c;
}

button[disabled] {
  background-color: #ae8681;
}

.cta-wrapper {
  padding: 0 10px;
}

.error-message {
  display: block;
  padding: 5px 0 0;
  color: #dc143c;
}
</style>
